<ngx-datatable #mydatatable class="material expandable" [headerHeight]="50" [columnMode]="'force'" [footerHeight]="50"
    [rowHeight]="'auto'" [rows]="data" [scrollbarH]='true' [externalPaging]="external"
    [count]="external ? page.totalElements : 0" [offset]="!external ? 0 : page.pageNumber" [limit]="page.size" (page)="setPage($event)">

    <!-- Row Detail Template -->
    <ngx-datatable-row-detail (toggle)="showDetail($event)">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
        <ion-item lines="none" class="detail-info ion-padding">
          <ion-label>
            <div class="info" *ngFor="let detail of detailFields">
              <ng-container *ngIf="detail.type === 'string' || !detail.type">
                <span class="title bold">{{detail.title}}</span>:<span class="text">{{row[detail.prop]}}</span>
              </ng-container>
              <ng-container *ngIf="detail.type === 'date'">
                <span class="title bold">{{detail.title}}</span>:<span class="text">{{row[detail.prop] | date:
                  'dd-MM-yyyy'}}</span>
              </ng-container>
            </div>
          </ion-label>
        </ion-item>
      </ng-template>
    </ngx-datatable-row-detail>
    <!-- Column Templates -->
    <ngx-datatable-column [frozenLeft]="true" *ngIf="detailFields.length > 0" [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false"
      [canAutoResize]="false">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
        <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded"
          title="Voir detail" (click)="toggleExpandRow(row)">
        </a>
      </ng-template>
    </ngx-datatable-column>
    <ng-container *ngFor="let colunm of columns">
      <ngx-datatable-column *ngIf="colunm.type === 'string' || !colunm.type" [frozenLeft]="colunm.frozenLeft"
        [name]="colunm.name" [prop]="colunm.prop"></ngx-datatable-column>
      <ngx-datatable-column *ngIf="colunm.type !== 'string' && colunm.type" [name]="colunm.name">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value">
          <ng-container *ngIf="colunm.type === 'date'">
            {{row[colunm.prop] | date: 'dd-MM-yyyy HH:mm:ss'}}
          </ng-container>
          <ng-container *ngIf="colunm.type === 'currency'">
            {{row[colunm.prop] | currency: 'XOF': 'symbol': undefined : 'fr'}}
          </ng-container>
        </ng-template>
      </ngx-datatable-column>
    </ng-container>

    <!-- <ngx-datatable-column name="Operation">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value">
        <ion-buttons *ngIf="canWrite" slot="end">
          <ion-button color="danger" (click)="delete(row)" slot="start">
            <ion-icon color="danger" slot="end" name="trash" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button (click)="edit(row)" slot="end">
            <ion-icon color="secondary" name="create" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ng-template>
    </ngx-datatable-column> -->
  </ngx-datatable>